import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { StoreUser } from '@app/models'
import { api } from '@services'

export const initialState = {
  isLoading: false,
  storeUser: {} as StoreUser
}

/* eslint no-debugger: "off" */
export const authenticate = createAsyncThunk<StoreUser, { userName: string, password: string }>(
  'storeUser/authenticate',
  async ({ userName, password }) => {
    const storeUser = await api.storeUser.authenticate({ userName, password })
    return storeUser
  }
)

export const fetchCurrentStoreUser = createAsyncThunk<StoreUser>(
  'storeUser/fetchCurrentStoreUser',
  async () => {
    const currentStoreUserId = localStorage.getItem('storeUserId') || ''
    const storeUser = await api.storeUser.fetchStoreUserById(currentStoreUserId)
    return storeUser
  }
)

const storeUserSlice = createSlice({
  name: 'storeUser',
  initialState,
  reducers: {
    logout: (): void => {
      localStorage.removeItem('storeUserId')
      localStorage.removeItem('jwtToken')
      localStorage.removeItem('refreshToken')
      window.location.replace('/login')
    }
  },
  extraReducers: builder => {
    builder.addCase(authenticate.pending, state => {
      state.isLoading = true
    })
    builder.addCase(authenticate.fulfilled, (state, action) => {
      state.storeUser = action.payload
      state.isLoading = false
    })
    builder.addCase(authenticate.rejected, state => {
      state.isLoading = false
    })
    builder.addCase(fetchCurrentStoreUser.pending, state => {
      state.isLoading = true
    })
    builder.addCase(fetchCurrentStoreUser.fulfilled, (state, action) => {
      state.storeUser = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchCurrentStoreUser.rejected, state => {
      state.isLoading = false
      window.location.replace('/login')
    })
  }
})

export const {
  logout
} = storeUserSlice.actions

export default storeUserSlice.reducer
